import { ViaParam } from '../intents/ViaParam';
import { makeLinkWithQueryParams } from '../intents/linkUtils';
import { getQueryParam } from '../routing/getQueryParam';
import { academy, academyTracks } from './productLinks';
import { getPortalId } from '../store/auth/selectors';
import { getHublet, getIsNewPortalCreated } from '../store/app/selectors';
import { getIntentLink } from '../intents/intentSelectors';
import { getApplicationLocale } from '../i18n/LocaleUtils';
export const getAcademyRedirect = state => {
  const portalId = getPortalId(state);
  const hublet = getHublet(state);
  const intentLink = getIntentLink(state);
  const isNewPortal = getIsNewPortalCreated(state);
  const params = {
    via: ViaParam.AcademySignup,
    newPortal: isNewPortal.toString(),
    awardType: '',
    language: getApplicationLocale()
  };

  if (intentLink) {
    return makeLinkWithQueryParams({
      link: intentLink,
      queryParamsToInclude: params,
      hublet
    });
  }

  let link = academy({
    portalId,
    hublet
  });
  const hubsSignupUrlQueryParam = getQueryParam('hubs_signup-url');

  if (hubsSignupUrlQueryParam === 'certification-day') {
    params['awardType'] = 'ONLY_SHOW_CERTIFICATE_COURSES';
    link = academyTracks({
      portalId,
      hublet
    });
  }

  return makeLinkWithQueryParams({
    link,
    queryParamsToInclude: params,
    hublet
  });
};